import React, { useState } from "react";
import axios from "../../axiosinstens";
import Logo from "../../assets/images/header/logo.jpg";
import swal from "sweetalert";
function Section1() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    axios
      .post("sendEmail", JSON.stringify(form), {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        if (response.data.success) {
          swal("Success", response.data.message, "success", {
            buttons: true, // or `true` to show default "OK"
          }).then(function () {
            window.location.reload();
          });
        } else {
          swal("Error", response.data.message, "error", {
            buttons: true, // or `true` to show default "OK"
          }).then(function () {
            window.location.reload();
          });
        }
      })
      .catch((error) => {
        console.error("Error registering:", error);
      });
  };
  return (
    <>
      <div className="contactdetails">
        <div className="container_row">
          <div className="conttact">
            <div className="conttactt">
              <img src={Logo} alt="Logo" className="logo" />
            </div>
            <div className="conttactt">
              <div className="con">
                <div className="contactboxicon">
                  <i class="fa-solid fa-envelope"></i>
                </div>
              </div>
              <div className="con">
                <div className="contactbox"> Email</div>
                <div className="contactbox">
                  <h4>host@spectacularseminars.com</h4>
                </div>
              </div>
            </div>
            <div className="conttactt">
              <div className="con">
                <div className="contactboxicon">
                  <i class="fa-solid fa-user"></i>
                </div>
              </div>
              <div className="con">
                <div className="contactbox"> Phone</div>
                <div className="contactbox">
                  <h4>855-454-2448</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="contactfrm">
            <div className="confrmleftt">
              <div className="formleft">
                <h2>Contact Us</h2>
                <h3>Have Any Query? Please Contact Us!</h3>
                <p>
                  {" "}
                  Please fill in the form below and one of us will get back to
                  you at the earliest.
                </p>
                <form onSubmit={handleSubmit} className="confrmm">
                  <div className="conname">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="conname">
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="conname">
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="conname">
                    <input
                      type="text"
                      name="phone"
                      placeholder="Your Phone Number"
                      onChange={handleChange}
                    />
                  </div>
                  <textarea
                    name="message"
                    placeholder="Message"
                    onChange={handleChange}
                  ></textarea>
                  <div className="consub">
                    <input type="submit" value="Submit" />
                  </div>
                </form>
              </div>
            </div>
            <div className="confrmleftt">
              <div className="formleftt">
                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d470832.0670212566!2d88.26618761480043!3d22.788545191101704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f8b526303b1a1f%3A0x65b80319fd28c36!2sV1%20Technologies!5e0!3m2!1sen!2sin!4v1714469077846!5m2!1sen!2sin"></iframe> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Section1;
